<template>
	<vs-navbar v-model="activeItem" class="nabarx">
		<div slot="title" class="pt-5 pb-5">
			<vs-navbar-title class="pr-0 pl-0">
				<span class="g-tools--description">{{ $t("Zonification.Tools") }}</span>
			</vs-navbar-title>
		</div>
		<div class="flex justify-end items-center mb-2">
			<vs-navbar-item index="1" v-if="activeRectangle">
				<a href="#" @click="selectTool('rectangle')" class="text-center">
					<feather-icon class="cursor-pointer" icon="SquareIcon" />
					<br /><small>{{ $t("Zonification.Rectangle") }}</small></a
				>
			</vs-navbar-item>
			<vs-navbar-item index="2" v-if="activePolyline">
				<a href="#" @click="selectTool('polyline')" class="text-center">
					<feather-icon class="cursor-pointer" icon="Edit2Icon" />
					<br /><small>{{ $t("Zonification.Polyline") }}</small></a
				>
			</vs-navbar-item>
			<vs-navbar-item index="3" v-if="activeMarker">
				<a href="#" @click="selectTool('marker')" class="text-center">
					<feather-icon class="cursor-pointer" icon="MapPinIcon" />
					<br /><small>{{ $t("Zonification.Marker") }}</small></a
				>
			</vs-navbar-item>
			<vs-navbar-item index="4" v-if="activeFillColor">
				<a href="#" class="text-center"
					><input type="color" v-model="shapeColor" name="" value="" /><br /><small>{{
						$t("Zonification.FillColor")
					}}</small></a
				>
			</vs-navbar-item>
			<vs-navbar-item index="5">
				<a href="#" class="text-center" v-if="false" @click="nuevaCapa">
					<feather-icon class="cursor-pointer" icon="LayersIcon" />
					<br /><small>{{ $t("Zonification.NewLayer") }}</small></a
				>
			</vs-navbar-item>
			<vs-navbar-item v-if="activePolygon && zonificationCreatePermission" index="6" class="pr-4">
				<vx-tooltip :text="$t('Zonification.Polygon')">
					<vs-button
						color="#FF8C34"
						type="filled"
						icon-pack="feather"
						icon="icon-octagon"
						@click.prevent="selectTool('Polygon')"
					></vs-button>
				</vx-tooltip>
			</vs-navbar-item>
			<vs-navbar-item v-if="activeCircle" index="7" class="pr-4">
				<vx-tooltip :text="$t('Zonification.Circle')">
					<vs-button
						color="#FF8C34"
						type="filled"
						icon-pack="feather"
						icon="icon-circle"
						@click.prevent="selectTool('Circle')"
					></vs-button>
				</vx-tooltip>
			</vs-navbar-item>
			<vs-navbar-item v-if="activeSelection || activeCircle" index="8" class="pr-4">
				<vx-tooltip :text="$t('Selection')">
					<vs-button
						color="primary"
						icon-pack="feather"
						icon="icon-navigation"
						@click.prevent="selectTool(null)"
					></vs-button>
				</vx-tooltip>
			</vs-navbar-item>
			<vs-navbar-item index="9" v-if="activeEditInfo" class="pr-4">
				<vx-tooltip :text="$t('Edit') + ' ' + $t('Information')">
					<vs-button
						color="primary"
						icon-pack="feather"
						icon="icon-edit"
						class="cursor-pointer"
						@click.prevent="editZone"
					></vs-button>
				</vx-tooltip>
			</vs-navbar-item>
			<vs-navbar-item index="10" v-if="activeRemoveFigure && activeRemove">
				<vx-tooltip :text="$t('RemoveFigure')">
					<vs-button
						color="primary"
						icon-pack="feather"
						icon="icon-x-square"
						class="cursor-pointer"
						@click.prevent="deleteShape"
					></vs-button>
				</vx-tooltip>
			</vs-navbar-item>
			<vs-navbar-item index="11" class="pr-4">
				<vx-tooltip :text="$t('Zonification.RemoveZones')">
					<vs-button
						v-if="activePolygon && zonificationDeletePermission"
						color="primary"
						icon-pack="feather"
						icon="icon-delete"
						@click.prevent="deleteZoneCapa"
					></vs-button>
				</vx-tooltip>
			</vs-navbar-item>
			<vs-navbar-item index="12" class="pr-4">
				<vx-tooltip :text="$t('general.ClearMap')">
					<vs-button
						v-if="(activePolygon || activeCircle) && zonificationDeletePermission"
						color="#FF4B55"
						icon-pack="feather"
						icon="icon-trash-2"
						@click.prevent="clearMapLayer"
					></vs-button>
				</vx-tooltip>
			</vs-navbar-item>
			<vs-navbar-item v-if="activeSettingsCapa" index="13">
				<vx-tooltip :text="$t('Zonification.Layer')">
					<vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
						<vs-button color="#FF8C34" type="filled" icon-pack="feather" icon="icon-layers"></vs-button>
						<vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
							<vs-dropdown-item @click="nuevaCapa">
								<feather-icon
									v-if="zonificationCreatePermission"
									class="cursor-pointer mr-2"
									icon="LayersIcon"
									svgClasses="h-5 w-5"
								/>
								&nbsp;{{ $t("Zonification.NewLayer") }}
							</vs-dropdown-item>
							<vs-dropdown-item
								@click="changeNameCapa"
								v-if="activeSettingsCapaOptions && zonificationUpdatePermission"
							>
								<feather-icon class="cursor-pointer mr-2" icon="Edit2Icon" svgClasses="h-5 w-5" />
								&nbsp;{{ $t("Zonification.EditName") }}
							</vs-dropdown-item>
							<vs-dropdown-item
								@click="deleteOnlyCapa"
								v-if="activeSettingsCapaOptions && zonificationDeletePermission"
							>
								<feather-icon class="cursor-pointer mr-2" icon="Trash2Icon" svgClasses="h-5 w-5" />
								&nbsp;{{ $t("Zonification.RemoveLayer.Title") }}
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</vx-tooltip>
			</vs-navbar-item>
			<vs-navbar-item index="14">
				<vs-button
					v-if="activeResource"
					color="primary"
					type="filled"
					class="btn-resource"
					icon-pack="feather"
					icon="icon-plus"
					@click.prevent="showPopupResource"
				>
					{{ $t("Resource.AssigResources") }}
				</vs-button>
			</vs-navbar-item>
			<vs-navbar-item index="15" class="pr-4">
				<vx-tooltip :text="$t('Save')">
					<vs-button
						v-if="
							activeAssignedResourceSave && zonificationUpdatePermission && zonificationCreatePermission
						"
						color="#FF8C34"
						icon-pack="feather"
						icon="icon-save"
						@click.prevent="assigZoneResource"
					></vs-button>
				</vx-tooltip>
			</vs-navbar-item>
			<vs-navbar-item index="16" v-if="activeDeleteAssignedResource && zonificationDeletePermission">
				<vx-tooltip :text="$t('Crud.Delete')">
					<vs-button
						color="#FF4B55"
						icon-pack="feather"
						icon="icon-trash"
						@click.prevent="deleteAssigZoneResource"
					></vs-button>
				</vx-tooltip>
			</vs-navbar-item>
		</div>
	</vs-navbar>
</template>

<script>
import Zone from "@/models/zone.js";
import {selectTool} from "../../utils/HereMap";
import {addInteraction, addSelectToFigure, removeInteraction} from "../../core/plugins/ol/OlAnuket";

export default {
	props: {
		mode: {
			type: Number,
			default: () => 0,
		},
		idCapa: {
			type: Number,
			default: () => 0,
		},
		selectedZone: {
			type: Zone,
			default: () => new Zone({}),
		},
		selectedLayer: null,
		selectedResource: {
			type: Array,
		},
		zonesSelected: {
			type: Array,
			default: () => [],
		},
		zonesResourceChecked: {
			type: Array,
			default: () => [],
		},
		zonesCheckedResource2: {
			type: Array,
			default: () => [],
		},
		modeAssigUpdate: {
			type: Boolean,
			default: () => false,
		},
		global: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			shapeColor: "#3EC9D6",
			activeItem: "0",
			activeRemoveFigure: false,
		};
	},
	methods: {
		selectTool(opc) {
			if (opc === "Polygon" || opc === "Circle") {
				this.activeRemoveFigure = false;
				addInteraction(opc, this.global.olMap, (newShape) => {
					this.$emit("callbackDrawEmit", newShape);
				});
			} else if (opc === null) {
				removeInteraction();
				if (this.mode == 0) {
					addSelectToFigure((feature) => {
						this.$emit("featureSelectedEmit", feature);
						if (feature) {
							this.activeRemoveFigure = true;
						} else {
							this.activeRemoveFigure = false;
						}
					});
				}
			} else {
				selectTool(opc, this.global);
				this.activeRemoveFigure = false;
			}
		},
		deleteShape() {
			this.$emit("deleteShapeEmit");
		},
		changeColor(fillColor) {
			this.$emit("changeColorEmit", fillColor);
		},
		nuevaCapa() {
			this.$emit("nuevaCapaEmit");
		},
		deleteZoneCapa() {
			this.$emit("deleteZoneCapaEmit");
		},
		clearMapLayer() {
			this.$emit("clearMapLayerEmit");
		},
		editZone() {
			this.$emit("editZoneEmit");
		},
		changeNameCapa() {
			this.$emit("changeNameCapaEmit");
		},
		deleteOnlyCapa() {
			this.$emit("deleteOnlyCapaEmit");
		},
		showPopupResource() {
			this.$emit("showPopupResourceEmit", true);
		},
		assigZoneResource() {
			this.$emit("assigZoneResourceEmit");
		},
		deleteAssigZoneResource() {
			this.$emit("deleteAssigZoneResourceEmit");
		},
	},
	computed: {
		activeCircle() {
			return this.mode === 0;
		},
		activeRectangle() {
			return false; //this.mode === 1 && this.idCapa > 0;
		},
		activePolygon() {
			if (this.mode === 1 && this.selectedLayer !== null) return true;
			else return false;
		},
		activePolyline() {
			return this.mode === 8;
		},
		activeMarker() {
			return this.mode === 8;
		},
		activeRemove() {
			return (this.mode === 1 && this.idCapa > 0) || this.mode === 0;
		},
		activeSelection() {
			if ((this.mode === 1 || this.mode === 0) && this.selectedLayer !== null) return true;
			else return false;
		},
		activeFillColor() {
			return false; //this.mode === 1 && this.idCapa > 0 && this.idCapa > 0;
		},
		activeNewCapa() {
			return this.mode === 1;
		},
		activeEditInfo() {
			if (this.mode === 1 && this.selectedZone.cartodb_id > 0) return true;
			else return false;
		},
		activeSettingsCapa() {
			if (this.mode === 1) return true;
			else return false;
		},
		activeSettingsCapaOptions() {
			if (this.mode === 1 && this.selectedLayer !== null) return true;
			else return false;
		},
		activeResource() {
			return this.mode === 2 && this.selectedResource.length === 0;
		},
		activeAssignedResourceSave() {
			return this.mode === 2 && this.selectedResource.length > 0;
		},
		activeDeleteAssignedResource() {
			return this.mode === 2 && this.selectedResource.length > 0 && this.modeAssigUpdate;
		},
		zonificationReadPermission() {
			return this.$store.getters.checkPermission("ZONIFICATION_R");
		},
		zonificationCreatePermission() {
			return this.$store.getters.checkPermission("ZONIFICATION_C");
		},
		zonificationUpdatePermission() {
			return this.$store.getters.checkPermission("ZONIFICATION_U");
		},
		zonificationDeletePermission() {
			return this.$store.getters.checkPermission("ZONIFICATION_D");
		},
	},
	watch: {
		shapeColor(fillColor) {
			this.changeColor(fillColor);
		},
	},
};
</script>
<style lang="scss" scoped>
.tools {
	font-style: normal;
	font-weight: bold;
	font-size: 15px;
	line-height: 18px;
	color: #484848;
}

.includeIconOnly {
	width: 25px !important;
	height: 25px !important;
}

.vs-navbar {
	box-shadow: none;
}

.btn-resource {
	height: 30px;
	width: 195px;
	font-size: 13px;
	font-style: normal;
	font-weight: bold;
	line-height: 16px;
}
</style>
